import React from 'react';

import Pagination from 'gatsby-core-theme/src/components/molecules/pagination';
import { BiArrowFromLeft } from '@react-icons/all-files/bi/BiArrowFromLeft';
import { BiArrowToRight } from '@react-icons/all-files/bi/BiArrowToRight';

export default (props) => <Pagination {...props} firstComp={<BiArrowToRight title='Right-pointing Arrow Icon'  />} lastComp={<BiArrowFromLeft  title='Right-pointing Arrow Icon' />} />;
